import { render } from "./NotEnoughGold.vue?vue&type=template&id=1eab412a"
import script from "./NotEnoughGold.vue?vue&type=script&lang=js"
export * from "./NotEnoughGold.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/NotEnoughGold.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1eab412a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1eab412a', __exports__)) {
    api.reload('1eab412a', __exports__)
  }
  
  module.hot.accept("./NotEnoughGold.vue?vue&type=template&id=1eab412a", () => {
    api.rerender('1eab412a', render)
  })

}


export default __exports__